import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Input } from 'antd';
import InputMask from 'react-input-mask';
import BaseComponent from 'components/BaseComponent';
import styledComp from 'components/StyledComp';

const propTypes = {
  form: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  extra: PropTypes.string,
  initialValue: PropTypes.string,
  placeholder: PropTypes.string,
  help: PropTypes.string,
  prefix: PropTypes.object,
  suffix: PropTypes.object,
  inputMask: PropTypes.string,
  isRequired: PropTypes.bool,
  isPassword: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  validator: PropTypes.func,
  onPressEnter: PropTypes.func,
  onBlur: PropTypes.func,
};

const defaultProps = {
  initialValue: '',
  placeholder: '',
  isRequired: false,
  isPassword: false,
};

@autobind
class FormInput extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      form,
      name,
      label,
      extra,
      initialValue,
      placeholder,
      help,
      prefix,
      suffix,
      inputMask,
      isRequired,
      isPassword,
      min,
      max,
      validator,
      onPressEnter,
      onBlur,
      ...layoutProps
    } = this.props;

    const { getFieldDecorator } = form;

    const requiredRule = { required: isRequired, message: 'This field should not be empty.' };
    const minRule = min !== undefined ? { min, message: `This field should contain at least ${min} characters.` } : undefined;
    const maxRule = max !== undefined ? { max, message: `This field should contain at most ${max} characters.` } : undefined;
    const rules = [requiredRule, minRule, maxRule, validator].filter(Boolean);

    // Choose the correct element type to use.
    const Elem = !isPassword ? Input : Input.Password;

    return (
      <styledComp.AntdFormItem
        {...layoutProps}
        label={label}
        extra={extra}
        help={help}
      >
        {inputMask &&
          getFieldDecorator(name, {
            rules,
            initialValue,
          })(
            <InputMask
              mask={inputMask}
              alwaysShowMask={false}
            >
              {inputProps => (
                <Elem
                  {...inputProps}
                  // ref={(input) => { this.titleInput = input; }}
                  disabled={this.props.disabled ? this.props.disabled : null}
                  type="text"
                  placeholder={placeholder}
                  prefix={prefix}
                  suffix={suffix}
                  onPressEnter={onPressEnter}
                  onBlur={onBlur}
                />
              )}
            </InputMask>,
          )
        }

        {!inputMask &&
          getFieldDecorator(name, {
            rules,
            initialValue,
          })(
            <Elem
              // ref={(input) => { this.titleInput = input; }}
              disabled={this.props.disabled ? this.props.disabled : null}
              type="text"
              placeholder={placeholder}
              prefix={prefix}
              suffix={suffix}
              onPressEnter={onPressEnter}
              onBlur={onBlur}
            />,
          )
        }
      </styledComp.AntdFormItem>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
FormInput.propTypes = propTypes;
FormInput.defaultProps = defaultProps;

export default FormInput;
